import { RevxTable, TableColumnsType } from 'components/RevxTable';
import { SpecialCsrItemDTO } from 'domains/orgDomain';
import { Checkbox, Input, Select, Form } from 'antd';
import CsrSelect from './CsrSelect';
import { useMount } from 'ahooks';
import orgService from 'services/orgService';
import { useOrgId } from 'hooks/useOrg';
import { useEffect, useState } from 'react';
import { SiteRoleEnum } from 'domains/roleDomain';
import { SelectValue } from './CsrSelect';
import { DeleteIcon } from 'components/Icons';
import { PlusOutlined } from '@ant-design/icons';
import { UnderlineText } from 'components/RevxTypography';
import { toast } from 'components/RevxMessage';

const { Buyer, Sourcer, Supplier } = SiteRoleEnum;

type CsrSpecificProductsProps = {
  initValue?: SpecialCsrItemDTO[];
  setLoading?: (loading: boolean) => void;
};

const productRow: SpecialCsrItemDTO = {
  sku: undefined,
  roles: [],
  contacts: [],
  serialNumber: undefined,
  fieldName: undefined,
};

const options = [
  {
    label: 'Buyer',
    value: Buyer,
  },
  {
    label: 'Sourcer',
    value: Sourcer,
  },
  {
    label: 'Supplier',
    value: Supplier,
  },
];

const CsrSpecificProducts = ({ initValue }: CsrSpecificProductsProps) => {
  const [orgCsrProductData, setOrgCsrProductData] = useState<
    SpecialCsrItemDTO[]
  >([]);
  const [skuList, setSkuList] = useState<SelectValue[]>([]);
  const orgId = useOrgId();
  const [csrProductForm] = Form.useForm();

  const setProductForm = (data?: SpecialCsrItemDTO[]) => {
    if (data?.length) {
      // csrProductForm.setFieldsValue({ specialCsrItems: data });
    }
  };

  useMount(async () => {
    setProductForm(initValue);
    const skus = await orgService.getOrgCsrSkuList(orgId, '');
    setSkuList(skus.map((item) => ({ label: item.name, value: item.id })));
  });

  useEffect(() => {
    setOrgCsrProductData(initValue || []);
  }, [initValue]);
  useEffect(() => {
    // setProductForm(orgCsrProductData);
  }, [orgCsrProductData]);

  const updateOrCreateOrgCsrProductItem = async (item: SpecialCsrItemDTO) => {
    // setLoading?.(true);
    const { createOrgCsrProductItem, updateOrgCsrProductItem } = orgService;
    let orgCsr;
    if (item.serialNumber) {
      orgCsr = await updateOrgCsrProductItem(orgId, item);
    } else {
      const { sku, contacts } = item;
      if (sku && !!contacts?.length) {
        try {
          orgCsr = await createOrgCsrProductItem(orgId, item);
        } catch (e) {
          toast.error('sku csr item already exists.');
          updateOrDelTmpProductItem(item);
        }
      } else {
        updateOrDelTmpProductItem(item);
      }
    }
    if (orgCsr) {
      setOrgCsrProductData(orgCsr.specialCsrItems);
    }
    // setLoading?.(false);
  };

  const updateOrDelTmpProductItem = (
    item: SpecialCsrItemDTO,
    isDel?: boolean
  ) => {
    const index = orgCsrProductData.findIndex(
      (i) => i.serialNumber === undefined
    );
    if (index > -1) {
      if (!isDel) {
        orgCsrProductData.splice(index, 1, item);
      } else {
        orgCsrProductData.splice(index, 1);
      }

      setOrgCsrProductData([...orgCsrProductData]);
    }
  };

  const removeOrgCsrProductItem = async (item: SpecialCsrItemDTO) => {
    // setLoading?.(true);
    const { removeOrgCsrProductItem } = orgService;
    if (item.serialNumber) {
      const csr = await removeOrgCsrProductItem(orgId, item);
      if (csr) {
        setOrgCsrProductData(csr.specialCsrItems);
      }
    } else {
      const index = orgCsrProductData.findIndex(
        (i) => i.serialNumber === undefined
      );
      if (index > -1) {
        orgCsrProductData.splice(index, 1);
        setOrgCsrProductData([...orgCsrProductData]);
      }
    }
    // setLoading?.(false);
  };

  const filterOption = (input: string, option: any) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
  };

  const columns: TableColumnsType<SpecialCsrItemDTO> = [
    {
      title: 'Product name',
      dataIndex: 'sku',
      width: 300,
      render: (value, record, index) => {
        return (
          <Select
            defaultValue={value?.id}
            showSearch
            options={skuList}
            filterOption={filterOption}
            onChange={async (v, o: any) => {
              await updateOrCreateOrgCsrProductItem({
                ...record,
                sku: {
                  id: o.value,
                  name: o.label,
                },
              });
            }}
          />
        );
      },
    },
    {
      title: 'Role',
      dataIndex: 'roles',
      width: 300,
      render: (value, record, index) => (
        <>
          <Checkbox.Group
            defaultValue={value}
            options={options}
            onChange={async (v) => {
              await updateOrCreateOrgCsrProductItem({
                ...record,
                roles: v as SiteRoleEnum[],
              });
            }}
          />
        </>
      ),
    },
    {
      title: 'Field label',
      dataIndex: 'fieldName',
      width: 400,
      render: (value, record, index) => (
        <Form.Item
          name={[index, 'fieldName']}
          rules={[{ required: true, message: '' }]}
        >
          <Input
            defaultValue={value}
            placeholder="Provide label here"
            onChange={async (event) => {
              const v = event.target.value.trim();
              if (v) {
                await updateOrCreateOrgCsrProductItem({
                  ...record,
                  fieldName: event.target.value,
                });
              }
            }}
          />
        </Form.Item>
      ),
    },
    {
      title: 'CSR contacts(up to two names)',
      dataIndex: 'csrs',
      width: 400,
      render: (value, record, index) => {
        const { contacts } = record;
        return (
          <>
            <CsrSelect
              initValue={contacts}
              onChange={async (v) => {
                await updateOrCreateOrgCsrProductItem({
                  ...record,
                  contacts: v,
                });
              }}
            />
          </>
        );
      },
    },
    {
      dataIndex: 'action',
      render: (value, record) => {
        return (
          <div>
            <span
              className="click"
              onClick={async () => {
                await removeOrgCsrProductItem(record);
              }}
            >
              <DeleteIcon />
            </span>
          </div>
        );
      },
    },
  ];

  const addProduct = async () => {
    setOrgCsrProductData([...orgCsrProductData, productRow]);
  };

  return (
    <div className="csr-product mt-40">
      <div className="csr-product__title bold">
        CSR contacts for specific products
      </div>
      <Form form={csrProductForm}>
        <RevxTable<SpecialCsrItemDTO>
          columns={columns}
          dataSource={orgCsrProductData}
          pagination={false}
          bordered={false}
          key={orgCsrProductData.length}
        />
      </Form>
      <div className="csr-product__add">
        <div className="csr-product__add__title click">
          <UnderlineText color="blue" onClick={addProduct}>
            <PlusOutlined /> Add product
          </UnderlineText>
        </div>
      </div>
    </div>
  );
};

export default CsrSpecificProducts;
